import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';

const styles = css`
  .vehicle-card-badge {
    width: 81px;
    padding: 2px 0;
    border-radius: 40px;
    display: flex;
    justify-content: center;
    background-color: ${colors.BLACK};
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    color: ${colors.WHITE};
  }
  .fresh-badge {
    background-color: ${colors.ALB1};
  }
  .hot-car-badge {
    background-color: ${colors.ALR1};
    background: linear-gradient(90deg, #f45c43 0%, #eb3349 52.08%, #d31c32 100%);
  }
  .price-drop-badge {
    background-color: ${colors.ALG1};
    width: 90px;
  }
  .viewed-badge {
    background-color: ${colors.BLACK};
  }
`;
export default styles;
